import questionsLSContainer from './QuestionsLSContainer';

/**
 * Contains information about prequalify modal questions. Saves the information to prequalifyLSContainer.
 */
class QuestionStorage {
	constructor() {
		this._setInitialValues();
	}

	_setInitialValues() {
		this._pageId = null;
		this._questionsOwnerPageId = null;
		this._totalQuestions = null;
		/** @type {null|string|boolean} */
		this._question = null;
		this._prevQuestions = [];
		this._redirectSourcePageId = null;
		this._filters = {};
		this._isQuestionDone = 0;
		this._showCloseButton = false;
		this._mandatoryPrequel = false;
		this._prequelId = null;
	}

	get pageId() {
		return this._pageId;
	}

	set pageId(value) {
		this._pageId = value;
	}

	get questionsOwnerPageId() {
		return this._questionsOwnerPageId;
	}

	set questionsOwnerPageId(value) {
		this._questionsOwnerPageId = value;
	}

	get totalQuestions() {
		return this._totalQuestions;
	}

	set totalQuestions(value) {
		this._totalQuestions = value;
	}

	get question() {
		return this._question;
	}

	set question(value) {
		this._question = value;
	}

	get filters() {
		return this._filters;
	}

	get showCloseButton() {
		return this._showCloseButton;
	}

	set showCloseButton(showCloseButton) {
		this._showCloseButton = showCloseButton;
	}

	get redirectSourcePageId() {
		return this._redirectSourcePageId;
	}

	set redirectSourcePageId(value) {
		this._redirectSourcePageId = value;
	}

	get prevQuestions() {
		return this._prevQuestions;
	}

	set prevQuestions(value) {
		this._prevQuestions = value;
	}

	get mandatoryPrequel() {
		return this._mandatoryPrequel;
	}

	set mandatoryPrequel(mandatoryPrequel) {
		this._mandatoryPrequel = mandatoryPrequel;
	}

	get prequelId() {
		return this._prequelId;
	}

	set prequelId(prequelId) {
		this._prequelId = prequelId;
	}

	isEmpty() {
		return Object.keys(this._filters).length === 0;
	}

	isInit() {
		return this._pageId !== null
			&& this._questionsOwnerPageId !== null
			&& this._totalQuestions !== null
			&& (this._question !== null || this._filters !== null);
	}

	saveToContainer() {
		if (this.isInit()) {
			// we use one character to spend less storage
			questionsLSContainer.set(this._pageId, {
				o: this._questionsOwnerPageId,
				t: this._totalQuestions,
				q: this._question,
				f: this._filters,
				d: this._isQuestionDone,
				l: this._redirectSourcePageId,
				c: this._showCloseButton,
			});
		}
	}

	initFromStorage(pageId) {
		const data = questionsLSContainer.get(pageId);

		if (data) {
			this._pageId = pageId;
			this._questionsOwnerPageId = data.o;
			this._totalQuestions = data.t;
			this._question = data.q;
			this._filters = data.f;
			this._isQuestionDone = data.d;
			this._redirectSourcePageId = this._redirectSourcePageId || data.l;
			this._showCloseButton = data.c;

			if (this._redirectSourcePageId) {
				const linkPageData = questionsLSContainer.get(this._redirectSourcePageId);
				this._filters = linkPageData.f;
			}
		}
	}

	/**
	 * Removes QuestionStorage data from storage, clears current object, so it becomes QuestionStorage.isInit() === false.
	 */
	removeFromStorage() {
		questionsLSContainer.remove(this._pageId);
		this._setInitialValues();
	}

	addFilter(filterType, filterValue) {
		this._filters[this._question] = {filterType, filterValue};
		this.saveToContainer();
	}

	addFilters(filters) {
		if (!this._filters) {
			this._filters = {};
		}

		this._filters = {...this._filters, ...filters};

		this.saveToContainer();
	}

	isLastQuestion() {
		return this._question === this._totalQuestions;
	}

	setIsQuestionDone() {
		this._isQuestionDone = 1;
		this.saveToContainer();
	}

	isQuestionDone() {
		return this._isQuestionDone;
	}

	clearAllForQuestionsOfOwnerPageIdAsync() {
		const self = this;

		setTimeout(function () {
			const questions = questionsLSContainer.getAllQuestions();

			for (const pageId in questions) {
				// TODO maybe add some asynchronous inside of the loop
				const question = questions[pageId];

				if (question && question.o === self._questionsOwnerPageId) {
					delete questions[pageId];
				}
			}

			questionsLSContainer.setAllQuestions(questions);
		}, 0);
	}

	addPrevQuestion(prevQuestion) {
		this._prevQuestions.push(prevQuestion);
	}

	getLastPrevQuestion() {
		return this._prevQuestions.pop();
	}
}

export default QuestionStorage;
